import React from "react";

import Button from "../../UI/Button";
import Hr from "../../UI/Hr";

const ProfileDetailsCard = (props) => {
  return (
    <div className="ProviderProfile__ProfileDetailsCard p-4 mb-3 mb-lg-4">
      <div className="d-flex justify-content-between">
        <h1 className="fs-16 ml-2 mb-3 pb-1 tw:font-bold">{props.heading}</h1>

        {props.isEditable && (
          <Button
            className={`ProviderProfile__ProfileDetailsCard-controls cursor mr-2 fs-14 mb-3 tw:font-bold ${
              props.edit ? "d-none" : ""
            }`}
            onClick={props.onclick}
          >
            Edit
          </Button>
        )}
      </div>
      <Hr />
      {props.children}
    </div>
  );
};

export default ProfileDetailsCard;
